export const getCatalogCardBg = (img: string | undefined, id: string | number) => {
  if (process.env.NODE_ENV !== 'development') return img
  return !!img ? img : `https://picsum.photos/280/110?rdm=${id}`
}
